import React, { useState, useEffect, } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faSave,
  faSearch,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Transportation.css";
import "../../Shared/Searchbar.css"; // Import your CSS file
import GoCast from "../../Images/GoCast.png";
import { useNavigate } from "react-router-dom";

function Transportation_Dashboard() {
  // Loading GIF
  const [isLoading, setIsLoading] = useState(false);
  // Search-bar
  const [searchOpen, setSearchOpen] = useState(false);
  // Table visibility
  const [tableVisible, setTableVisible] = useState(true);

  const [selectedFilter, setSelectedFilter] = useState("");

  const navigate = useNavigate();

  // Filter Second Grid By Taking The Load ID & Filter in Second API
  const [selectedLoadID, setSelectedLoadID] = useState(null);

  // Search Toggle
  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  };

  // Toggle table visibility
  const toggleTableVisibility = () => {
    setTableVisible(!tableVisible);
  };

  //        API CODE
  const [apiData1, setApiData1] = useState([]);
  const [apiData2, setApiData2] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Adjust this number as needed

  const fetchData = async () => {
    setIsLoading(true); // Load GIF
    const username = "manager"; // Replace with your username
    const password = "manager"; // Replace with your password
    const apiUrl1 =
      "https://77.92.189.102/iiprecastverticaldemo/api/v1/BaqSvc/IIT_TransportationHeadDB_v1(PRECAST)"; // Adjust the URL as needed

    try {
      const response = await fetch(apiUrl1, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Basic " + btoa(username + ":" + password),
        },
      });
      

      if (!response.ok) {
        throw new Error("Network response was not ok for Grid 1");
      }

      ////////////////////////// Grid 1 Data /////////////////////////////////
      const data1 = await response.json();
      // Check if data is an object and contains the 'value' property which is an array
      if (
        typeof data1 === "object" &&
        data1 !== null &&
        Array.isArray(data1.value)
      ) {
        setApiData1(data1.value);
        setIsLoading(false); // Loading GIF
      } else {
        console.error(
          'API response does not contain the expected array in the "value" property:',
          data1
        );
      }
    } catch (error) {
      console.error("There was a problem with your fetch operation:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []); // Fetch data on component mount

  const renderTableRows = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = apiData1.slice(startIndex, endIndex);

    return currentItems.map((item, index) => (
      <tr
        key={index}
        onClick={() => {
          setSelectedLoadID(item.UD103_Key1);
        }}
      >
        <td
              className="blue-hyper"
              onClick={() =>
                navigate(
                  `/transportation/details/${item.UD103_Key1}`
                )
              }
            >{item.UD103_Key1}</td>
        <td>{item.UD103_Date01?.split("T")[0] || ""}</td>
        <td>{item.UD103_Date02?.split("T")[0] || ""}</td>
        <td>{item.UD103_ShortChar05}</td>
        <td>{item.UD103_Number01}</td>
        <td>{item.UD103_ShortChar07}</td>
        <td>{item.UD103_Character02}</td>
        <td>{item.UD103_Character03}</td>
        <td>{item.UD103_ShortChar01}</td>
        <td>{item.UD103_ShortChar04}</td>
        <td>{item.Vendor_VendorID}</td>
        <td>{item.Vendor_Name}</td>
        <td>{item.UD103_Number04}</td>
        <td>{item.UD103_Number05}</td>
        <td>{item.UD103_ShortChar03}</td>
        <td>{item.UD103_Character06}</td>
        <td>{item.Warehse_Description}</td>
        <td>{item.UD103_Character01}</td>
        <td>{item.UD103_Number06}</td>
        <td>{item.UD103_ShortChar08}</td>
        <td>{item.UD103_Character05}</td>
        <td>{item.UD103_Number08}</td>
        <td>{item.UD103_Number09}</td>
        <td>{item.UD103_Number10}</td>
        <td>{item.UD103_Character09}</td>
      </tr>
    ));
  };

  // const renderTableRows2 = () => {
  //   const startIndex = (currentPage - 1) * itemsPerPage;
  //   const endIndex = startIndex + itemsPerPage;
  //   const currentItems = apiData2.slice(startIndex, endIndex);
  //   return currentItems.map((item, index) => (
  //     <tr key={index}>
  //       <td >{item.UD103_Key1}</td>
  //       <td>{item.UD103_Date01}</td>
  //       <td>{item.UD103A_Character01}</td>
  //       <td>{item.UD103A_Character02}</td>
  //       <td>{item.UD103A_ShortChar07}</td>
  //       <td>{item.Calculated_QtyUOM}</td>
  //       <td>{item.PartLot_Ton_c}</td>
  //       <td>{item.UD103_ShortChar05}</td>
  //       <td>{item.UD103_Date02}</td>
  //       <td>{item.UD103_ShortChar01}</td>
  //       <td>{item.Warehse_Description}</td>
  //       <td>{item.UD103A_Character04}</td>
  //       <td>{item.Warehse1_Description}</td>
  //       <td>{item.UD103_Character04}</td>
  //       <td>{item.ProdGrup_Description}</td>
  //       <td>{item.UD103A_Number06}</td>
  //     </tr>
  //   ));
  // };
  const goToNextPage = () => {
    const totalPages = Math.ceil(apiData1.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage1 = () => {
    const totalPages = Math.ceil(apiData2.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage1 = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  return (
    <div className="TruckMastertable">
      {isLoading && (
        <div className="loading-overlay">
          <img src={GoCast} alt="Loading..." />
        </div>
      )}
      <div className="card rebartable">
        <div className="card-header-trans">
          <button
            type="button"
            className="toggle-table-icon"
            onClick={toggleTableVisibility}
          >
            <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
          </button>
          <h2 className="panel-title-trans">Transportation</h2>
          <div className="Element-id-container-drptrans">
            <select
              className="Elementidinput-trans"
              type="text"
              name="optionlist"
              onChange={(e) => setSelectedFilter(e.target.value)}
            >
              <option value="" selected disabled>
                ALL
              </option>
              <option>Open</option>
              <option>Closed</option>
              <option>In Transit</option>
              <option value="">ALL</option>
              <option>Cancelled</option>
            </select>
          </div>

          <div className="ctrl-btns-trans">
            {/* Existing buttons */}
            {/* <button className="btn" id='add'>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                        <Tooltip
                            anchorSelect="#add"
                            content="Add"
                            place='bottom'
                        />
                        <button className="btn" id='save'>
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <Tooltip
                            anchorSelect="#save"
                            content="Save"
                            place='bottom'
                        /> */}
            {/* <button
              type="button"
              className="search-icon"
              onClick={toggleSearch}
            >
              <FontAwesomeIcon icon={faSearch} />
            </button>
            <Tooltip
              anchorSelect=".search-icon"
              content="Advanced Search"
              place="bottom"
            /> */}
            {/* New button to toggle table visibility */}

            {/* Existing search div */}
            <div
              className={`main-search-bar ${searchOpen ? "open" : ""}`}
              id="searchBar"
              style={{ height: "650px", overflowY: "scroll" }}
            >
              {/* Search form */}
              {/* <form className="search-filter">
                <h3 className="search-title">
                  Search Filter <FontAwesomeIcon icon={faSearch} />
                </h3>
                <input type="text" placeholder="Load=" name="filter1" />
                <input type="date" placeholder="Loading Date" name="filter2" />
                <input type="date" placeholder="To" name="filter3" />
                <input type="date" placeholder="Offload Date" name="filter3" />
                <input type="date" placeholder="To" name="filter3" />
                <input type="text" placeholder="Project >=" name="filter3" />
                <input type="text" placeholder="Condition >= " name="filter3" />
                <input
                  type="text"
                  placeholder="Supplier Name >= "
                  name="filter3"
                />
                <input type="text" placeholder="PO Num = " name="filter3" />
                <input
                  type="text"
                  placeholder="From Stockyard >= "
                  name="filter3"
                />
                <input type="text" placeholder="Transp.Name " name="filter3" />
                <input type="text" placeholder="Load Type >= " name="filter3" />
                <button type="submit">Search</button>
                <button type="reset" onClick={toggleSearch}>
                  Cancel
                </button>
              </form> */}
            </div>
          </div>
        </div>
        {/* Conditionally render the table */}
        {tableVisible && (
          <div className="card-body">
            <div class="table-responsive">
              <div className="scrollable-table-body">
                <table className="table table-bordered">
                  <thead className="table-primary">
                    <tr className="bg-primary text-white text-nowrap">
                      <th>Load</th>
                      <th>Loading Date</th>
                      <th>Offload Date</th>
                      <th>Project</th>
                      <th>Load Tons</th>
                      <th>Trailer</th>
                      <th>Driver Name</th>
                      <th>Driver Mobile No</th>
                      <th>Load Type</th>
                      <th>Condition</th>
                      <th>Supplier ID</th>
                      <th>ٍSupplier Name</th>
                      <th>PO Num</th>
                      <th>PO Line</th>
                      <th>Load Status</th>
                      <th>From Stockyard</th>
                      <th>To Stockyard</th>
                      <th>Transporter Name</th>
                      <th>Capacity</th>
                      <th>Truck ID</th>
                      <th>To Bin</th>
                      <th>Height</th>
                      <th>Width</th>
                      <th>Length</th>
                      <th>Resource ID</th>
                    </tr>
                  </thead>
                  <tbody>{renderTableRows()}</tbody>
                </table>
              </div>
            </div>
            <div className="pagination">
              <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <button
                onClick={goToNextPage}
                disabled={
                  currentPage === Math.ceil(apiData1.length / itemsPerPage)
                }
              >
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          </div>
        )}
      </div>
      {/* <div className="card rebartable">
        <div className="card-header">
          <button
            type="button"
            className="toggle-table-icon"
            onClick={toggleTableVisibility}
          >
            <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
          </button>
          <h2 className="panel-title">Details</h2>
        </div> */}
        {/* Conditionally render the table */}
        {/* {tableVisible && (
          <div className="card-body">
            <div class="table-responsive">
              <div className="scrollable-table-body">
                <table className="table table-bordered"> */}
                  {/* Table content */}
                  {/* <thead className="table-primary">
                    <tr className="bg-primary text-white text-nowrap">
                      <th>Load</th>
                      <th>Loading Date</th>
                      <th>PartNum</th>
                      <th>Element Num</th>
                      <th>UOM</th>
                      <th>Qty</th>
                      <th>Ton</th>
                      <th>Project</th>
                      <th>Offload Date</th>
                      <th>Delivery Type</th>
                      <th>From Stockyard</th>
                      <th>From Bin</th>
                      <th>To Stockyard</th>
                      <th>To Bin</th>
                      <th>Product Group</th>
                      <th>Erection Seq</th>
                    </tr>
                  </thead>
                  <tbody>{renderTableRows2()}</tbody>
                </table>
              </div>
            </div> */}
            {/* <div className="pagination">
              <button onClick={goToPreviousPage1} disabled={currentPage === 1}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <button
                onClick={goToNextPage1}
                disabled={
                  currentPage === Math.ceil(apiData1.length / itemsPerPage)
                }
              >
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          </div> */}
        {/* )} */}
      {/* </div> */}
    </div>
  );
}

export default Transportation_Dashboard;
